module.exports = __webpack_public_path__ + "static/img/9a.0bd0b27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/9a.jpg
// module id = r8D2
// module chunks = 0